import { useEffect, useRef } from "react";
import "./AboutPage.css";
import playVideo from "../../utils/playVideo.js";
import about_page_video from "../../assets/Videos/about_page_video.mp4";
import CubesAnim from "../Animation/CubesAnim";

const AboutPage = () => {
  let ref = useRef();
  useEffect(() => {
    playVideo(ref.current);
  }, []);
  return (
    <div className="aboutPage_wrapper">
      <div className="about_page_txt">
        Above is a young but powerful company which will take you as far as you
        can see when looking in the night sky. We started gathering the best
        scientists from all over the world, first to reach than to build a
        facility on Kepler-22b. That planet is too gorgeous, so we decided to
        bring you with us. If you need more details, go to Crew then Trips page,
        and let us know.
      </div>
      <video
        src={about_page_video}
        muted
        loop
        className="about_page_video"
        ref={ref}
      ></video>
      <CubesAnim />
    </div>
  );
};

export default AboutPage;
